import styled from 'styled-components';
import { Typ20 } from 'dc/Typ';
import CampaignCodeInput from 'account/common/CampaignCodeInput';

export const CodeInput = styled(CampaignCodeInput)`
  @media (min-width: 768px) {
    max-width: 320px;
    margin-top: 40px;
  }

  @media (max-width: 767px) {
    margin-top: 24px;
  }
`;

export const NoCode = styled(Typ20)`
  color: white;
  text-align: center;
  max-width: 320px;
`;
